<template>
    <BreadCrumb PageTitle="Ajouter un menu" />
    <AddMenu />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue"
    import AddMenu from "@/components/Menus/AddMenu.vue";
  
    export default defineComponent({
      name: "AddMenuPage",
      components: {
        BreadCrumb,
        AddMenu,
      },
    });
  </script>